<template>
	<section>
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item class="pull-right">
					<el-button type="primary" @click="addFormVisible=true">Add Self Storage</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table stripe :data="warehouses" highlight-current-row v-loading="listLoading" @selection-change=""
				  style="width: 100%;">
			<el-table-column type="index">
			</el-table-column>
			<el-table-column prop="address" label="Address" >
			</el-table-column>
			<el-table-column prop="city" label="City" >
			</el-table-column>
			<el-table-column prop="state" label="State" >
			</el-table-column>
			<el-table-column prop="zipCode" label="Zip Code" >
			</el-table-column>
			<el-table-column label="Action">
				<template slot-scope="scope">
					<el-button size="small" @click="getWarehousesById(scope.row.warehouseNo)">Edit</el-button>
					<el-button type="danger" size="small" @click="deleteWarehouses(scope.row.warehouseNo)">Delete</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="" :page-size="20" :total="total"
						   style="float:right;">
			</el-pagination>
		</el-col>


		<!--新增界面-->
		<el-dialog title="Add warehouse" :visible.sync="addFormVisible" :close-on-click-modal="false">
			<el-form :model="warehouseForm" label-width="180px" :rules="formRules" ref="warehouseForm">
				<el-form-item label="Address" prop="address" >
					<el-input type="text" v-model="warehouseForm.address"></el-input>
				</el-form-item>
				<el-form-item label="City" prop="city">
					<el-input type="text" v-model="warehouseForm.city"></el-input>
				</el-form-item>
				<el-form-item label="State" prop="state">
					<el-input type="text" v-model="warehouseForm.state"></el-input>
				</el-form-item>
				<el-form-item label="Zip Code" prop="zipCode">
					<el-input type="text" v-model="warehouseForm.zipCode"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="addWarehouse" :loading="addLoading">Submit</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="Edit warehouse" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editWarehouseObj" label-width="180px" :rules="formRules" ref="editWarehouseObj">
				<el-form-item label="State" prop="state">
					<el-input type="text" v-model="editWarehouseObj.state"></el-input>
				</el-form-item>
				<el-form-item label="City" prop="city">
					<el-input type="text" v-model="editWarehouseObj.city"></el-input>
				</el-form-item>
				<el-form-item label="Address" prop="address" >
					<el-input type="text" v-model="editWarehouseObj.address"></el-input>
				</el-form-item>
				<el-form-item label="Zip Code" prop="zipCode">
					<el-input type="text" v-model="editWarehouseObj.zipCode"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="editWarehouse" :loading="addLoading">Submit</el-button>
			</div>
		</el-dialog>
	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {getWarehouses,getWarehousesById,deleteWarehouses,addWarehouses} from '../../api/warehouseService';
    import {defaultPageSize} from "../../globalVar";

    export default {
        data() {
            return {
                categoryOption: [{
                    value: 'Bill Pay',
                    label: 'Bill Pay'
                }, {
                    value: 'Bank Transfer',
                    label: 'Bank Transfer'
                }],
                currencyOption: [{
                    value: 'USD',
                    label: 'United States Dollar'
                }, {
                    value: 'CNY',
                    label: 'China Yuan Renminbi'
                }, {
                    value: 'BTC',
                    label: 'Bitcoin'
                }],
                filters: {
                    name: ''
                },
                editWarehouseObj:{},
                warehouses: [],

                listLoading: false,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                formRules: {
                    state: [
                        {required: true, message: 'State is required', trigger: 'blur'}
                    ],
                    city: [
                        {required: true, message: 'City is required', trigger: 'blur'}
                    ],
                    address: [
                        {required: true, message: 'Address is required', trigger: 'blur'}
                    ],
                    zipCode: [
                        {required: true, message: 'Zip Code is required', trigger: 'blur'}
                    ]
                },
                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                //新增界面数据
                warehouseForm: {
                    state: '',
                    city: '',
                    address: '',//Credit card company for bill pay,Bank name for bank transfer.
                    zipCode: '',//Card network for bill pay,Account type for bank transfer
                    admin: ''
                },

                page:1,
                pageSize:defaultPageSize,
                total: 0,

            }
        },
        methods: {
            formatAddress (row, column) {
                return row.state+" "+row.city+" "+row.address;
            },
            pageChange(val){
                this.page = val;
                this.getWarehouses();
            },
            deleteWarehouses(id){
                this.$confirm("Are you sure?","Warning",{
                    type:"warning"
                }).then(()=>{
                    let param = {
                        warehouseNo:id
                    };
                    deleteWarehouses(param).then((res)=>{
                        if(res.status===200){
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.getWarehouses();
                        }else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            })
                        }
                    })
                }).catch(()=>{

                })
            },
            getWarehousesById(id){
                let param = {
                    warehouseNo: id
                };
                getWarehousesById(param).then((res)=>{
                    if(res.status===200){
                        this.editWarehouseObj = res.result.warehouse;
                        this.editFormVisible = true;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getWarehouses() {
                this.listLoading = true;
                let param = {
                    current: this.page,
                    size:this.pageSize,
                    condition:this.filters.name
                };
                getWarehouses(param).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.warehouses = res.result.records;
                        this.total=res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                }).catch(error => {
                    this.listLoading = false;
                    console.log(error)
                })
            },
            addWarehouse(){
                this.$refs.warehouseForm.validate((valid)=>{
                    if(valid){
                        this.addLoading = true;
                        addWarehouses(this.warehouseForm).then((res)=>{
                            this.addLoading = false;
                            this.$refs["warehouseForm"].resetFields();
                            if(res.status===200){
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                });
                                this.addFormVisible = false;
                                this.getWarehouses();
                            }else{
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                })
                            }
                        }).catch((err)=>{
                            console.log(err);
                            this.addLoading = false;
						})
                    }
                })
            },
            editWarehouse(){
                this.$refs.editWarehouseObj.validate((valid)=>{
                    if(valid){
                        this.addLoading = true;
                        addWarehouses(this.editWarehouseObj).then((res)=>{
                            this.addLoading = false;
                            if(res.status===200){
                                this.$message({
                                    message: res.message,
                                    type: 'success'
                                });
                                this.editFormVisible = false;
                                this.getWarehouses();
                            }else{
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                })
                            }
                        }).catch((err)=>{
                            console.log(err);
                            this.addLoading = false;
						})
                    }
                })
            }
        },
        mounted() {
            this.getWarehouses();
        }
    }

</script>


// WEBPACK FOOTER //
// warehouse.vue?dea421f0